import React from "react";
import app from "../../api/app.js";
import T1beerlist from "./templates/t1-beerlist";

class SingleApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      app: {name:'loading'},
      content:{},
      id: props.id,
      loading:true,
  };
  // console.log(this.state)
}

  getAppFromApi(){
    app.getSingleApp(this.state.id)
    .then((app)=> {
      this.setState({
        loading:false,
        app: app.data.data,
        content: app.data.data.content
      })

      // setTimeout(()=>{this.getAppFromApi()},5000)
    })
    .catch((error)=>{
      console.log(error)
      this.setState({
        loading:false,
        errorMessage:error.message
      })
    })
    // setTimeout(()=>{this.getAppFromApi()},5000)
  }

  updateAppOnApi(){
    // console.log('this.state.app',this.state.app)
    app.updateSingleApp(this.state.app)
    .then((results)=>{
      // console.log('updated app',results)
    })
    .catch((error)=>{
      console.log(error)
    })
  }

  componentDidMount(){
    this.getAppFromApi();
    setInterval(function(){
      this.getAppFromApi()
    }.bind(this),10000);
  };



  render() {
    return (
      <div>
        <T1beerlist content={this.state.content}/>
      </div>
    );
  }
}

export default SingleApp;



// WEBPACK FOOTER //
// ./src/components/application/application.js